import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { raiseGAEvent } from "../../../Utils/network";

export const notify = (errorResponse: string) => {
  toast.dismiss();
  toast.error(errorResponse, {
    position: toast.POSITION.BOTTOM_CENTER,
  });

  const GAObject = {
    "new_Category":"HP_api error",
    "new_Action":"",
    "new_Label":errorResponse
  }
  raiseGAEvent(GAObject);
};
